var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IdfTextIcon',{staticClass:"p-back-button",attrs:{"icon-left":"arrow-left-outlined"},nativeOn:{"click":function($event){return _vm.$router.back()}}},[_vm._v(_vm._s(_vm.$t('ctx.discount.back')))])
}
var staticRenderFns = []

export { render, staticRenderFns }